import React from 'react';
import ARange from 'antd-mobile/lib/range';



export default class Range extends ARange {}